import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AEMRoutes, RoutePrefix } from './core/constants/routes.constant';
import { StaticContentComponent } from './modules/static-content/static-content.component';
import { HomeComponent } from './common/home/home.component';
import { UnauthGuard } from './core/guards/unauth.guard';
import { DesktopDeviceGuard } from './core/guards/desktop-device.guard';
import { PackageInsertComponent } from './common/package-insert/package-insert.component';
import { AuthGuard } from './core/guards/auth.guard';
import { GenericPopUpResolver } from '../app/shared/resolvers/generic-pop-up.resolver.service';
import { AddPopUpResolver } from '../app/shared/resolvers/add-pop-up.resolver.service';
import { SalePopUpResolver } from '../app/shared/resolvers/sale-pop-up.resolver.service';
import { MajorHelpComponent } from './common/major-help/major-help.component';
import { MajorAmazonComponent } from './common/amazon/amazon.component';
const routes: Routes = [
  {
    path: RoutePrefix.Static,
    // loadChildren: './modules/static-content/static.content.module#StaticContentModule'
    component: StaticContentComponent
  },
  {
    path: RoutePrefix.Home,
    component: HomeComponent,
    canActivate: [UnauthGuard,DesktopDeviceGuard]
  },
  {
    path: RoutePrefix.MyHome,
    component: HomeComponent,
    resolve: {
      genericPopups: GenericPopUpResolver,
      adPopups: AddPopUpResolver,
      salePopup: SalePopUpResolver
    },
    canActivate: [AuthGuard, DesktopDeviceGuard]
  },
  {
    path: RoutePrefix.nfm,
    redirectTo: '/contact-us'
  },
  {
    path: RoutePrefix.NFM,
    redirectTo: '/contact-us'
    //loadChildren: () => import('./modules/contact-us/contact-us.module').then(m => m.ContactUsModule)
  },
  {
    path: RoutePrefix.ContactUs,
    loadChildren: () => import('./modules/contact-us/contact-us.module').then(m => m.ContactUsModule)
  },
  {
    path: RoutePrefix.Products,
    loadChildren: () => import('./modules/products/products.module').then(m => m.ProductsModule)
  },
  {
    path: AEMRoutes.MajorAboutUS,
    loadChildren: () => import('./modules/about-us/about-us.module').then(m => m.AboutUsModule)
  },
  {
    path: AEMRoutes.Major.News,
    loadChildren: () => import('./modules/major-news/major-news.module').then(m => m.MajorNewsModule)
  },

  {
    path: RoutePrefix.Register,
    loadChildren: () => import('./modules/register/register.module').then(m => m.RegisterModule)
  },
  {
    path: RoutePrefix.Chat,
    loadChildren: () => import('./modules/chat/chat.module').then(m => m.ChatModule)
  },
  {
    path: RoutePrefix.TrackAndTrace,
    loadChildren:
      () => import('./modules/track-and-trace/track-and-trace.module').then(m => m.TrackAndTraceModule)
  },
  {
    path: RoutePrefix.Order,
    loadChildren: () => import('./modules/order/order.module').then(m => m.OrderModule)
  },
  {
    path: RoutePrefix.User,
    loadChildren: () => import('./modules/user/user.module').then(m => m.UserModule)
  },
  {
    path: RoutePrefix.CreditCards,
    loadChildren: () => import('./modules/credit-cards/credit-cards.module').then(m => m.CreditCardsModule)
  },
  {
    path: RoutePrefix.PackageInsert,
    component: PackageInsertComponent
  },
  {
    path: RoutePrefix.help,
    component: MajorHelpComponent,
  },
  {
    path: RoutePrefix.Amazon,
    component: MajorAmazonComponent,
  },
 
  { path: '', redirectTo: '/home', pathMatch: 'full' }
  // { path: '**', redirectTo: '/home'  }
]; 

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
